import { useState } from '#app'
import { readonly, type Ref } from 'vue'

export type MobileAppData = {
    bearerToken: string | null
    capacitorOrigin: string | null
}

const MOBILE_APP_DATA_STATE_KEY = 'mobile-app-data'

export function useMobileAppData(): Ref<MobileAppData> {
    const state = useState<MobileAppData>(MOBILE_APP_DATA_STATE_KEY, () => {
        return {
            bearerToken: null,
            capacitorOrigin: null
        }
    })
    return readonly(state)
}

export function setMobileAppData(data: MobileAppData) {
    const state = useState<MobileAppData>(MOBILE_APP_DATA_STATE_KEY, () => {
        return {
            bearerToken: null,
            capacitorOrigin: null
        }
    })
    state.value = data
}

export function setBearerToken(token: string | null) {
    const state = useState<MobileAppData>(MOBILE_APP_DATA_STATE_KEY, () => {
        return {
            bearerToken: null,
            capacitorOrigin: null
        }
    })
    state.value.bearerToken = token
}
